import { render, staticRenderFns } from "./AddBook.vue?vue&type=template&id=9885a684&scoped=true"
import script from "./AddBook.vue?vue&type=script&lang=js"
export * from "./AddBook.vue?vue&type=script&lang=js"
import style0 from "./AddBook.vue?vue&type=style&index=0&id=9885a684&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9885a684",
  null
  
)

export default component.exports